import { newId } from './common.js';
import { CURRENT_SCHEMA_VERSION, PAGE_SIZES } from './document.js';
import { DEFAULT_FONT } from './fonts.js';
/** Standard-Seitenrahmen „Standard“ mit Name- und Datumsfeld. */
export function defaultFrame(id = newId()) {
    return {
        id,
        name: 'Standard',
        header: [
            {
                blocks: [
                    { kind: 'name', label: 'Name:' },
                    { kind: 'date', label: 'Datum:' },
                ],
            },
        ],
        footer: [],
        taskBlocks: 1,
        pointsColumn: { enabled: false, sumInFooter: false },
        lines: [],
        font: { family: 'andika' },
        fontSize: 12,
    };
}
export function emptyPage(frameId) {
    return {
        id: newId(),
        ...(frameId ? { frameId } : {}),
        items: [],
        guides: [],
    };
}
/** Leeres Arbeitsblatt im A4-Hochformat. */
export function createDocument(options = {}) {
    const now = (options.now ?? new Date()).toISOString();
    const frame = defaultFrame();
    return {
        schemaVersion: CURRENT_SCHEMA_VERSION,
        id: newId(),
        meta: {
            title: options.title ?? 'Neues Arbeitsblatt',
            tags: [],
            authorId: options.authorId ?? 'unbekannt',
            createdAt: now,
            updatedAt: now,
        },
        setup: {
            output: 'paper',
            size: options.size ?? { ...PAGE_SIZES.A4 },
            orientation: options.orientation ?? 'portrait',
            margins: { top: 15, right: 15, bottom: 15, left: 15 },
            duplex: false,
            lineWeight: 1,
            solutionColor: 'solution',
            placeValueColors: null,
            locale: 'de-DE',
            handDrawn: false,
            grid: { step: 5, visible: false },
        },
        styles: {
            defaultFont: { ...DEFAULT_FONT },
            defaultFontSize: 16,
            textColor: '#1a1a1a',
        },
        frames: { [frame.id]: frame },
        assets: {},
        pages: [emptyPage(frame.id)],
        groups: {},
        seed: options.seed ?? Math.floor(Math.random() * 1_000_000),
        language: { syllableOverrides: {} },
    };
}
//# sourceMappingURL=factory.js.map